import { Linkedin, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#F9FAFB] border-t border-gray-100 py-20" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-6">
            <img
              src="/assets/huminence-wordmark-green.png"
              alt="Huminence Technologies"
              className="h-6 w-auto"
              data-testid="footer-logo"
            />
            <p className="mt-5 text-sm text-gray-500 max-w-xs leading-relaxed">
              Building Technology That Empowers Humanity.
            </p>
            <div className="mt-7 flex items-center gap-3">
              <a
                href="https://www.linkedin.com/in/upinderr-maggu-24a11414/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-linkedin"
                aria-label="LinkedIn"
                className="h-10 w-10 rounded-full bg-white border border-gray-200 flex items-center justify-center text-gray-500 hover:text-[#7F9F43] hover:border-[#7F9F43] transition-colors duration-300"
              >
                <Linkedin size={17} />
              </a>
              <a
                href="mailto:upinderr@huminence.com"
                data-testid="footer-email"
                aria-label="Email"
                className="h-10 w-10 rounded-full bg-white border border-gray-200 flex items-center justify-center text-gray-500 hover:text-[#7F9F43] hover:border-[#7F9F43] transition-colors duration-300"
              >
                <Mail size={17} />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs tracking-[0.2em] uppercase text-gray-400 font-semibold mb-5">
              Explore
            </p>
            <ul className="space-y-3 text-sm">
              {[
                ["Home", "#home"],
                ["About", "#about"],
                ["Romii", "#romii"],
                ["Vision", "#vision"],
                ["Contact", "#contact"],
              ].map(([label, href]) => (
                <li key={label}>
                  <a href={href} className="text-gray-500 hover:text-[#111827] transition-colors duration-300">
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="flex items-center gap-3">
              <img src="/assets/romii-icon.png" alt="Romii" className="h-9 w-9" />
              <div>
                <p className="text-sm font-semibold text-[#111827]">Romii™</p>
                <p className="text-xs text-gray-400 leading-snug mt-0.5">
                  The flagship product of
                  <br />
                  Huminence Technologies Inc.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-gray-200/70 flex flex-col sm:flex-row justify-between gap-3">
          <p className="text-xs text-gray-400">
            Copyright © {new Date().getFullYear()} Huminence Technologies Inc. All rights reserved.
          </p>
          <p className="text-xs text-gray-400 font-serif-italic">
            Technology that Empowers Humanity.
          </p>
        </div>
      </div>
    </footer>
  );
}
